import { get as getStoreValue } from 'svelte/store';
import CurrentStateStore from '@shared/svelte/Stores/CurrentStateStore';

let setupCurrentStateStore;

export default setupCurrentStateStore = ($rootScope) => {
  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, from, fromParams) {
    if (toState) {
      CurrentStateStore.update((n) => toState && toState.name);
    }
  });
};
